(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-api"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const request = async (path, options) => {
      const response = await fetch(root + path, {
        ...options,
        headers: { Accept: 'application/json', ...(options.headers || {}) },
      });

      let data = null;
      try {
        data = await response.json();
      } catch (error) {
        data = null;
      }

      if (!response.ok) {
        const error = new Error((data && (data.description || data.message)) || '');
        error.status = response.status;
        error.data = data;
        throw error;
      }

      return data;
    };

    let moneyFormat = null;

    const readMoneyFormat = () => {
      if (moneyFormat !== null) return moneyFormat;
      moneyFormat = '';
      const config = document.querySelector('[data-pp-cart-config]');
      if (!config) return moneyFormat;
      try {
        const raw = String(JSON.parse(config.textContent).moneyFormat || '');
        moneyFormat = new DOMParser().parseFromString(raw, 'text/html').documentElement.textContent || '';
      } catch (error) {
        moneyFormat = '';
      }
      return moneyFormat;
    };

    const groupDigits = (value, decimals, thousands, decimal) => {
      const [whole, fraction] = value.toFixed(decimals).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? `${grouped}${decimal}${fraction}` : grouped;
    };

    // A /discount/ link visited earlier leaves this cookie, and checkout reads
    // it, so clearing codes expires it too (the domain form covers a cookie set
    // for the shop's parent domain).
    const expireCodeCookie = () => {
      const expired = 'discount_code=; path=/; max-age=0';
      document.cookie = expired;
      document.cookie = `${expired}; domain=.${window.location.hostname.replace(/^www\./, '')}`;
    };

    const codeList = (value) =>
      String(value || '')
        .split(',')
        .map((entry) => entry.trim().toLowerCase())
        .filter(Boolean);

    // The cookie's codes, or an empty list when there is none (or it can't be read).
    const cookieCodes = () => {
      const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (!match) return [];
      try {
        return codeList(decodeURIComponent(match[1]));
      } catch (error) {
        return codeList(match[1]);
      }
    };

    window.ppCart = {
      root,
      codesBusy: false,

      // keepalive lets the request finish when the page navigates straight after.
      async setDiscount(code, { keepalive = false } = {}) {
        const value = String(code || '').trim();
        // Removing one code of several must not leave it in the cookie either.
        const sent = codeList(value);
        if (!value || cookieCodes().some((entry) => !sent.includes(entry))) expireCodeCookie();

        const cart = await request('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: value }),
          keepalive,
        });

        if (cart) window.ppCart.updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('pp:cart-changed', { detail: { cart } }));
        return cart;
      },

      // The offer code box can leave a code that lost to a better one on the
      // cart, so Remove sends the other codes back and that one applies again.
      // A code that can't be matched clears them all, so its pill still goes.
      async removeDiscount(code) {
        const cart = await request('cart.js', {});
        const key = String(code || '').trim().toLowerCase();
        const codes = ((cart && cart.discount_codes) || []).map((entry) => String(entry.code));
        const rest = codes.filter((entry) => entry.toLowerCase() !== key);
        return window.ppCart.setDiscount(key && rest.length < codes.length ? rest.join(',') : '');
      },

      // Runs on a real click only, never on hover, focus or pointerdown. A plain
      // click waits for the code (2.5 s at most, and goes anyway on an error),
      // then navigates; a click that opens a new tab or window just sends it.
      applyCodeAndGo(code, href, event) {
        const send = () => window.ppCart.setDiscount(code, { keepalive: true });
        const modified =
          event && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);

        if (modified) {
          send().catch(() => {});
          return Promise.resolve();
        }

        if (event) event.preventDefault();
        return new Promise((resolve) => {
          let timer = 0;
          let gone = false;
          const go = () => {
            if (gone) return;
            gone = true;
            clearTimeout(timer);
            window.location.assign(href);
            resolve();
          };
          timer = setTimeout(go, 2500);
          send().then(go, go);
        });
      },

      add(formData, sections, signal) {
        if (sections) formData.append('sections', sections);
        return request('cart/add.js', { method: 'POST', body: formData, signal });
      },

      change({ line, quantity, sections, sectionsUrl }, signal) {
        return request('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity, sections, sections_url: sectionsUrl }),
          signal,
        });
      },

      setBusy(button, busy) {
        if (!button) return;
        if (busy) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      },

      updateCount(count) {
        document.querySelectorAll('[data-cart-count]').forEach((badge) => {
          badge.textContent = count;
          badge.hidden = !(count > 0);
        });
      },

      parseSection(html, selector) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector(selector);
      },

      // Matches Liquid's money_without_trailing_zeros, which the theme uses
      // everywhere: whole rupees drop the ".00", paise still show.
      formatMoney(cents) {
        const value = Number(cents) / 100;
        if (!Number.isFinite(value)) return '';
        const decimals = Number.isInteger(value) ? 0 : 2;

        const format = readMoneyFormat();
        const pattern = /\{\{\s*(\w+)\s*\}\}/;
        if (!pattern.test(format)) return groupDigits(value, decimals, ',', '.');

        return format.replace(pattern, (match, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return groupDigits(value, 0, ',', '.');
            case 'amount_with_comma_separator':
              return groupDigits(value, decimals, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return groupDigits(value, 0, '.', ',');
            case 'amount_with_apostrophe_separator':
              return groupDigits(value, decimals, "'", '.');
            case 'amount_with_space_separator':
              return groupDigits(value, decimals, ' ', ',');
            case 'amount_no_decimals_with_space_separator':
              return groupDigits(value, 0, ' ', ',');
            case 'amount_with_period_and_space_separator':
              return groupDigits(value, decimals, ' ', '.');
            default:
              return groupDigits(value, decimals, ',', '.');
          }
        });
      },
    };

    // Every a[data-discount-code] on the page, including sections re-rendered
    // later. Bubble phase, so a carousel that cancels the click after a swipe
    // (and stops it) wins. auxclick catches the middle click that opens a tab.
    const onCodeLink = (event) => {
      if (event.defaultPrevented || !(event.target instanceof Element)) return;
      if (event.type === 'auxclick' && event.button !== 1) return;
      const link = event.target.closest('a[data-discount-code][href]');
      const code = link ? link.dataset.discountCode.trim() : '';
      if (!code) return;

      // A link that opens elsewhere keeps its own navigation.
      if (link.target && link.target !== '_self') {
        window.ppCart.setDiscount(code, { keepalive: true }).catch(() => {});
        return;
      }
      window.ppCart.applyCodeAndGo(code, link.href, event);
    };

    document.addEventListener('click', onCodeLink);
    document.addEventListener('auxclick', onCodeLink);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const nativeClose = HTMLDialogElement.prototype.close;
    const closing = new WeakMap();
    const enhanced = new WeakSet();
    // Dialogs sliding out, each with a promise that settles once its 'close'
    // listeners (such as quick add's focus return) have run.
    const waiting = new Map();

    const settle = (dialog) => {
      const entry = waiting.get(dialog);
      if (!entry) return;
      clearTimeout(entry.timer);
      waiting.delete(dialog);
      entry.resolve();
    };

    const track = (dialog) => {
      if (waiting.has(dialog)) return;
      const entry = {};
      entry.promise = new Promise((resolve) => {
        entry.resolve = resolve;
      });
      entry.timer = setTimeout(() => settle(dialog), 1000);
      waiting.set(dialog, entry);
    };

    const clearClosing = (dialog) => {
      const state = closing.get(dialog);
      if (state) {
        clearTimeout(state.timer);
        dialog.removeEventListener('animationend', state.onEnd);
        closing.delete(dialog);
      }
      dialog.classList.remove('is-closing');
    };

    const closeNow = (dialog, returnValue) => {
      const wasOpen = dialog.open;
      if (wasOpen) {
        if (returnValue === undefined) nativeClose.call(dialog);
        else nativeClose.call(dialog, returnValue);
      }
      clearClosing(dialog);
      // No 'close' event follows when the dialog was already closed.
      if (!wasOpen) settle(dialog);
    };

    // Keeps a dialog open when it is opened again while sliding out.
    const cancelClose = (dialog) => {
      if (!dialog || !dialog.open) return;
      clearClosing(dialog);
      settle(dialog);
    };

    const whenDialogsClosed = () => {
      if (waiting.size === 0) return null;
      return Promise.all([...waiting.values()].map((entry) => entry.promise));
    };

    const closeDialog = (dialog, returnValue) => {
      if (!dialog || !dialog.open || closing.has(dialog)) return;
      // A class already set elsewhere means an exit animation has just run.
      if (reducedMotion.matches || dialog.classList.contains('is-closing')) {
        closeNow(dialog, returnValue);
        return;
      }

      dialog.classList.add('is-closing');
      const name = getComputedStyle(dialog).animationName;
      if (!name || name === 'none') {
        closeNow(dialog, returnValue);
        return;
      }

      const onEnd = (event) => {
        if (event.target === dialog && !event.pseudoElement && event.animationName === name) {
          closeNow(dialog, returnValue);
        }
      };
      closing.set(dialog, { onEnd, timer: setTimeout(() => closeNow(dialog, returnValue), 400) });
      track(dialog);
      dialog.addEventListener('animationend', onEnd);
    };

    const enhanceDialog = (dialog) => {
      if (enhanced.has(dialog)) return;
      enhanced.add(dialog);
      dialog.close = (returnValue) => closeDialog(dialog, returnValue);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog(dialog);
      });
      // Also covers a close that skipped the animation, such as a forced
      // Escape. Settling waits a task so every other 'close' listener runs first.
      dialog.addEventListener('close', () => {
        clearClosing(dialog);
        setTimeout(() => settle(dialog), 0);
      });
    };

    const enhanceWithin = (node) => {
      if (!(node instanceof Element)) return;
      if (node.matches('dialog[data-soft-close]')) enhanceDialog(node);
      node.querySelectorAll('dialog[data-soft-close]').forEach(enhanceDialog);
    };

    window.ppCart.closeDialog = closeDialog;
    window.ppCart.cancelClose = cancelClose;
    window.ppCart.whenDialogsClosed = whenDialogsClosed;

    const watchDialogs = () => {
      enhanceWithin(document.body);
      // The quick add sheet is cloned from its template into <body> on first
      // use, and the theme editor swaps whole section wrappers.
      new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach(enhanceWithin));
      }).observe(document.body, { childList: true });
    };

    if (document.body) watchDialogs();
    else document.addEventListener('DOMContentLoaded', watchDialogs);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    class LanguageSwitcher extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');

      this.addEventListener('click', (event) => {
        const segment = event.target.closest('.language-switcher__segment');
        if (segment && segment.getAttribute('aria-current') === 'true') {
          event.preventDefault();
          return;
        }

        const option = event.target.closest('.language-switcher__option');
        if (!option) return;
        const input = this.querySelector('[data-language-input]');
        if (input) input.value = option.value;
      });

      document.addEventListener('click', (event) => {
        if (this.contains(event.target)) return;
        if (this.details) this.details.open = false;
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details) this.details.open = false;
      });
    }
  }

  if (!customElements.get('language-switcher')) {
    customElements.define('language-switcher', LanguageSwitcher);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-region"] && !Shopify.designMode) return;
  try {
    (() => {
    const region = document.getElementById('live-region');

    window.ppAnnounce = (text) => {
      if (!region) return;
      region.textContent = '';
      requestAnimationFrame(() => {
        region.textContent = text;
      });
    };

    const header = document.querySelector('site-header');
    if (!header || !('ResizeObserver' in window)) return;

    const observer = new ResizeObserver((entries) => {
      const height = Math.round(entries[0].contentRect.height);
      document.documentElement.style.setProperty('--header-offset', `${height}px`);
    });
    observer.observe(header);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["offer-code-form"] && !Shopify.designMode) return;
  try {
    class OfferCodeForm extends HTMLElement {
    connectedCallback() {
      if (this.form) return;
      this.input = this.querySelector('[data-offer-code-input]');
      this.button = this.querySelector('[data-offer-code-apply]');
      this.message = this.querySelector('[data-offer-code-message]');
      this.form = this.input ? this.input.form : null;
      if (!this.form) return;

      // The script checks the code itself: the browser's bubbles stay away and
      // the optional field stops reading as required.
      this.form.noValidate = true;
      this.input.required = false;
      this.input.removeAttribute('pattern');
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.input.addEventListener('input', () => {
        if (this.message && this.message.dataset.tone === 'error') this.show('');
      });
    }

    async onSubmit(event) {
      // A comma would split the code in two on the cart, so it counts as a space.
      const code = this.input.value.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
      if (!code) {
        event.preventDefault();
        this.report(this.dataset.textEmpty, 'error', this.focusInside());
        return;
      }

      const cart = window.ppCart;
      // Without the cart helpers the form posts to /cart/update as usual.
      if (!cart || typeof cart.setDiscount !== 'function') return;
      event.preventDefault();
      // One code change at a time: a Remove or an Apply still on its way (maybe
      // from a box a re-render has since replaced) would undo this one.
      if (cart.codesBusy) return;

      const host = this.closest('cart-drawer, cart-form');
      cart.codesBusy = true;
      cart.setBusy(this.button, true);
      if (host) host.setAttribute('aria-busy', 'true');

      try {
        await this.run(code, host);
      } finally {
        cart.codesBusy = false;
        cart.setBusy(this.button, false);
        if (host) host.removeAttribute('aria-busy');
      }
    }

    async run(code, host) {
      let outcome;
      try {
        outcome = await this.apply(code);
      } catch (error) {
        outcome = { status: 'error' };
      }

      const texts = {
        applied: this.dataset.textApplied,
        best: this.dataset.textBest,
        already: this.dataset.textAlready,
        invalid: this.dataset.textInvalid,
        error: this.dataset.textError,
      };
      const text = String(texts[outcome.status] || '').split('%code%').join(code.toUpperCase());
      const tone = outcome.status === 'invalid' || outcome.status === 'error' ? 'error' : 'success';
      let keepFocus = this.focusInside();
      const refreshed = Boolean(outcome.changed && host && typeof host.refresh === 'function');

      if (refreshed) {
        try {
          await host.refresh();
        } catch (error) {
          // The code is already on the cart when only the refresh failed, so a
          // reload shows the right totals.
          window.location.reload();
          return;
        }
        // Focus that the re-render dropped (it was elsewhere in the panel) comes
        // back to the box too, rather than stranding on the page.
        const active = document.activeElement;
        keepFocus = keepFocus || !active || active === document.body;
      }

      // A re-render (the refresh, or a quantity change meanwhile) replaces this
      // box; the result goes to the one on the page now.
      const box = this.isConnected ? this : host && host.querySelector('offer-code-form');
      if (!box || typeof box.report !== 'function') {
        if (window.ppAnnounce) window.ppAnnounce(text);
        return;
      }
      box.report(text, tone, keepFocus);
      // The re-render scrolls the drawer's list back to the top, where the box
      // and its message would be out of sight.
      if (refreshed) box.scrollIntoView({ block: 'nearest' });
    }

    // Resolves with { status, changed }; status is applied, best, already or
    // invalid. Rejects on a network failure.
    async apply(code) {
      const cart = window.ppCart;
      const key = code.toLowerCase();
      const find = (list, wanted) => list.find((entry) => String(entry.code).toLowerCase() === wanted);

      const response = await fetch(`${cart.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('');
      const before = (await response.json()).discount_codes || [];
      const current = find(before, key);
      // Re-rendered anyway: the cart UI can be older than the cart (a page
      // restored with Back, or an Apply whose reply never arrived).
      if (current && current.applicable) return { status: 'already', changed: true };

      // The codes already on the cart go back with the new one, so it is added
      // rather than swapped in. None of the store's offers combine, so Shopify
      // marks all but the best saving as not applicable.
      const previous = before.map((entry) => entry.code);
      const wanted = previous.filter((entry) => String(entry).toLowerCase() !== key).concat(code);

      let after;
      try {
        after = await cart.setDiscount(wanted.join(','));
      } catch (error) {
        // A 4xx reply is the cart turning the code down, not a lost connection.
        if (error.status >= 400 && error.status < 500 && error.status !== 429) return { status: 'invalid' };
        throw error;
      }

      const codes = (after && after.discount_codes) || [];
      const added = find(codes, key);
      if (added && added.applicable) {
        const displaced = before.some((entry) => {
          const now = entry.applicable ? find(codes, String(entry.code).toLowerCase()) : null;
          return Boolean(now && !now.applicable);
        });
        return { status: displaced ? 'best' : 'applied', changed: true };
      }

      // An unknown code is left out of the reply and an unusable one comes back
      // as not applicable. Put the earlier list back so neither lingers.
      const same =
        codes.length === before.length && codes.every((entry) => find(before, String(entry.code).toLowerCase()));
      if (!same) {
        // Left on the cart it would ride along with every later code, so the
        // restore gets a second try; if that fails too, say the connection let
        // the shopper down rather than that the code was wrong.
        let restored = false;
        for (let attempt = 0; attempt < 2 && !restored; attempt += 1) {
          if (attempt) await new Promise((resolve) => setTimeout(resolve, 800));
          try {
            await cart.setDiscount(previous.join(','));
            restored = true;
          } catch (error) {
            restored = false;
          }
        }
        if (!restored) return { status: 'error' };
      }
      return { status: 'invalid' };
    }

    // Safari doesn't focus a tapped button, so focus that fell back to the
    // page counts as still being in the box.
    focusInside() {
      const active = document.activeElement;
      return !active || active === document.body || this.contains(active);
    }

    report(text, tone, focus) {
      this.show(text, tone);
      const wasOnInput = document.activeElement === this.input;
      if (tone === 'error') {
        if (focus) {
          this.input.focus({ preventScroll: true });
          this.input.select();
        }
      } else {
        this.input.value = '';
        if (focus) this.input.focus({ preventScroll: true });
      }
      // Focus landing on the field reads the message through aria-describedby,
      // so the live region only speaks when focus didn't move there (it was
      // already on the field, stayed elsewhere, or the browser refused).
      const described = !wasOnInput && document.activeElement === this.input;
      if (!described && window.ppAnnounce) window.ppAnnounce(text);
    }

    show(text, tone) {
      if (!this.message) return;
      const slot = this.message.querySelector('[data-offer-code-text]');
      if (slot) slot.textContent = text;
      this.message.dataset.tone = text ? tone || '' : '';
      this.message.hidden = !text;
      if (text && tone === 'error') this.input.setAttribute('aria-invalid', 'true');
      else this.input.removeAttribute('aria-invalid');
    }
  }

  if (!customElements.get('offer-code-form')) {
    customElements.define('offer-code-form', OfferCodeForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.ppQuickAdd) {
    const quickAdd = {
      dialog: null,
      product: null,
      trigger: null,
      cache: new Map(),

      build() {
        if (this.dialog) return this.dialog;
        const template = document.querySelector('[data-quick-add-template]');
        const source = template && template.content.firstElementChild;
        if (!source) return null;

        const dialog = source.cloneNode(true);
        document.body.append(dialog);
        this.dialog = dialog;

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog || event.target.closest('[data-quick-add-close]')) this.close();
        });

        dialog.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-index]')) this.update();
        });

        dialog.addEventListener('close', () => {
          const box = dialog.querySelector('[data-form-status]');
          if (box) box.hidden = true;
          if (this.trigger && this.trigger.isConnected) this.trigger.focus();
        });

        const form = dialog.querySelector('[data-quick-add-form]');
        if (form) form.addEventListener('pp:cart-added', () => this.close());

        return dialog;
      },

      async load(url) {
        if (this.cache.has(url)) return this.cache.get(url);
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const product = await response.json();
        if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
          throw new Error('empty');
        }
        this.cache.set(url, product);
        return product;
      },

      async open(trigger) {
        const dialog = this.build();
        const url = trigger.dataset.quickAdd;
        if (!dialog || !url) {
          window.location.href = trigger.href;
          return;
        }

        this.trigger = trigger;
        trigger.setAttribute('aria-busy', 'true');

        try {
          const product = await this.load(url);
          this.render(product, trigger.href);
          if (!dialog.open) dialog.showModal();
          const focusTarget =
            dialog.querySelector('[data-option-index]:checked') || dialog.querySelector('[data-quick-add-submit]');
          if (focusTarget) focusTarget.focus();
        } catch (error) {
          window.location.href = trigger.href;
        } finally {
          trigger.removeAttribute('aria-busy');
        }
      },

      close() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      },

      optionValues(product, option, index) {
        if (option && typeof option === 'object' && Array.isArray(option.values)) return option.values;
        return [...new Set(product.variants.map((variant) => variant.options[index]))];
      },

      render(product, href) {
        const dialog = this.dialog;
        this.product = product;

        dialog.querySelector('[data-quick-add-title]').textContent = product.title;
        dialog.querySelector('[data-quick-add-link]').href = href;

        const initial = product.variants.find((variant) => variant.available) || product.variants[0];
        const container = dialog.querySelector('[data-quick-add-options]');
        container.replaceChildren();

        (product.options || []).forEach((option, index) => {
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'quick-add__option';

          const legend = document.createElement('legend');
          legend.className = 'quick-add__legend';
          legend.textContent = typeof option === 'string' ? option : option.name;
          fieldset.append(legend);

          const chips = document.createElement('div');
          chips.className = 'quick-add__chips';

          this.optionValues(product, option, index).forEach((value, valueIndex) => {
            const id = `quick-add-${product.id}-${index}-${valueIndex}`;

            const input = document.createElement('input');
            input.type = 'radio';
            input.className = 'quick-add__input visually-hidden';
            input.id = id;
            input.name = `quick-add-option-${index}`;
            input.value = value;
            input.dataset.optionIndex = String(index);
            input.checked = Boolean(initial && initial.options[index] === value);

            const label = document.createElement('label');
            label.className = 'quick-add__chip';
            label.htmlFor = id;
            label.textContent = value;

            chips.append(input, label);
          });

          fieldset.append(chips);
          container.append(fieldset);
        });

        this.update();
      },

      update() {
        const dialog = this.dialog;
        const product = this.product;
        const inputs = [...dialog.querySelectorAll('[data-option-index]')];
        const selected = [];
        inputs.forEach((input) => {
          if (input.checked) selected[Number(input.dataset.optionIndex)] = input.value;
        });

        const variant = product.variants.find((candidate) =>
          candidate.options.every((value, index) => value === selected[index])
        );

        inputs.forEach((input) => {
          const position = Number(input.dataset.optionIndex);
          const possible = product.variants.some(
            (candidate) =>
              candidate.available &&
              candidate.options.every((value, index) =>
                index === position ? value === input.value : value === selected[index]
              )
          );
          if (input.nextElementSibling) input.nextElementSibling.dataset.unavailable = String(!possible);
        });

        const available = Boolean(variant && variant.available);
        dialog.querySelector('[data-quick-add-id]').value = variant ? variant.id : '';

        const submit = dialog.querySelector('[data-quick-add-submit]');
        submit.disabled = !available;
        if (available) submit.textContent = dialog.dataset.textAdd;
        else submit.textContent = variant ? dialog.dataset.textSoldOut : dialog.dataset.textUnavailable;

        this.renderPrice(variant || product.variants[0]);
        this.renderImage(variant);
      },

      renderPrice(variant) {
        const box = this.dialog.querySelector('[data-quick-add-price]');
        box.replaceChildren();
        if (!variant || !window.ppCart || typeof window.ppCart.formatMoney !== 'function') return;

        const current = document.createElement('span');
        current.className = 'price__current';
        current.textContent = window.ppCart.formatMoney(variant.price);
        box.append(current);

        const onSale = Number(variant.compare_at_price) > Number(variant.price);
        box.classList.toggle('price--on-sale', onSale);
        if (!onSale) return;

        const compare = document.createElement('s');
        compare.className = 'price__compare';
        const hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        hidden.textContent = this.dialog.dataset.textRegular;
        compare.append(hidden, ` ${window.ppCart.formatMoney(variant.compare_at_price)}`);
        box.append(compare);
      },

      renderImage(variant) {
        const media = this.dialog.querySelector('[data-quick-add-media]');
        const product = this.product;
        let source = variant && variant.featured_image && variant.featured_image.src;
        if (!source && product.featured_image) {
          source = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
        }

        media.replaceChildren();
        if (!source) return;

        const url = new URL(source, window.location.href);
        url.searchParams.set('width', '240');

        const image = document.createElement('img');
        image.src = url.toString();
        image.alt = '';
        image.width = 240;
        image.height = 240;
        image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
        image.addEventListener('error', () => image.classList.add('is-loaded'), { once: true });
        media.append(image);
        if (image.complete) image.classList.add('is-loaded');
      },
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-add]');
      if (!trigger || event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!document.querySelector('[data-quick-add-template]')) return;

      event.preventDefault();
      if (trigger.getAttribute('aria-busy') === 'true') return;
      quickAdd.open(trigger);
    });

    window.ppQuickAdd = quickAdd;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;

    document.querySelectorAll('[data-whatsapp-template]').forEach((link) => {
      let pageUrl = link.dataset.whatsappProductUrl;
      try {
        const url = new URL(pageUrl);
        url.searchParams.set('variant', variant.id);
        pageUrl = url.toString();
      } catch (error) {
        return;
      }

      const text = link.dataset.whatsappTemplate
        .replace('[[variant]]', () => variant.title || '')
        .replace('[[url]]', () => pageUrl);

      link.href = `https://wa.me/${link.dataset.whatsappNumber}?text=${encodeURIComponent(text)}`;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
